<template>
  <div class="container d-flex align-items-center ">
    <div class="card m-auto p-5">
      <div class="card-title">
        <h3>Forget Password</h3>
      </div>
      <div class="card-body">
        <Form @submit="handleSubmit">
          <div class="form-group">
            <label for="email">Email</label>
            <Field name="email" type="text" class="form-control" />
            <ErrorMessage name="email" class="error-feedback" />
          </div>

          <div class="form-group text-center">
            <button
              class="btn btn-primary btn-block "
              :disabled="loading"
              type="submit"
            >
              <span
                v-show="loading"
                class="spinner-border spinner-border-sm"
              ></span>
              <span>Submit</span>
            </button>
            <p class="mt-5">A link will be sent to your email.</p>
            <p>Please check the link and reset your password!</p>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
  name: "Login",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({
      email: yup.string().required("Username is required!"),
    });

    return {
      loading: false,
      message: "",
      schema,
    };
  },
  methods: {
    handleSubmit() {
      return;
    },
  },
};
</script>

<style scoped>
html,
body {
  height: 100%;
}

.container {
  height: 100vh;
}

body {
  display: flex;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}
.form-group {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
h3 {
  margin: 20px;
}
</style>
